<script lang="ts">
  import type { Snippet } from 'svelte';
  import { portal } from '@zag-js/svelte';

  import { usePopoverContext } from '../use-popover-context';
  import { popoverStyles } from '../popover-styles';

  const popover = usePopoverContext();

  const { children }: { children?: Snippet } = $props();

  const classes = popoverStyles();
</script>

<div
  use:portal={{ disabled: !popover.api.portalled }}
  {...popover.api.getPositionerProps()}
  class={classes.positioner}
>
  {#if children}
    {@render children()}
  {/if}
</div>
